function addEventLoggerToHireButtons() {
  const hireButtons = Array.from(document.querySelectorAll('a.kg-btn')).filter((element) => element.innerText === '화이트큐브 채용 바로가기');

  for (let i = 0; i < hireButtons.length; i++) {
    hireButtons[i].addEventListener('click', function (event) {
      if (!gtag) return;

      const articleTitle = document.querySelector('.article-title').innerText;

      gtag('event', '화이트큐브_채용_바로가기_click', {
        'article': articleTitle,
      });
    });
  }
}

function addEventLoggerToTopNavigation() {
  const menus = Array.from(document.querySelectorAll('.gh-head-navigation-primary > a'));
  const hireMenu = menus.find((menu) => menu.innerText === '채용 공고');

  if (!hireMenu) return;

  hireMenu.addEventListener('click', function (event) {
    if (!gtag) return;

    gtag('event', '채용_공고_click');
  });
}

function addEventLoggerToLogo() {
  const logo = document.querySelector('.gh-head-logo');

  if (!logo) return;

  logo.addEventListener('click', function (event) {
    if (!gtag) return;

    gtag('event', '로고_click');
  });
}

document.addEventListener('DOMContentLoaded', function () {
  addEventLoggerToHireButtons();
  addEventLoggerToTopNavigation();
  addEventLoggerToLogo();
});
